import { render, staticRenderFns } from "./k-field-tree.vue?vue&type=template&id=14c2807b&scoped=true"
import script from "./k-field-tree.vue?vue&type=script&lang=js"
export * from "./k-field-tree.vue?vue&type=script&lang=js"
import style0 from "./k-field-tree.vue?vue&type=style&index=0&id=14c2807b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c2807b",
  null
  
)

export default component.exports